<script lang="ts">
	import { t } from '$lib/stores/i18n';
	import { DateTime } from 'luxon';

	interface Props {
		date: DateTime;
		dateOrigin?: DateTime;
	}

	let { date, dateOrigin = DateTime.now() }: Props = $props();

	let diff = $derived(date.diff(dateOrigin, ['years', 'months', 'days']));

	let diffDays = $derived(Math.trunc(diff.days) * -1);
	let diffMonths = $derived(Math.trunc(diff.months) * -1);
	let diffYears = $derived(Math.trunc(diff.years) * -1);
</script>

{#if diffYears !== 0}
	{$t('dateDiff.years', { years: diffYears.toString() })}
{/if}
{#if diffMonths !== 0}
	{$t('dateDiff.months', { months: diffMonths.toString() })}
{/if}
{#if diffDays !== 0 || (diffYears === 0 && diffMonths === 0)}
	{$t('dateDiff.days', { days: diffDays.toString() })}
{/if}
